import {useAuth0} from '@auth0/auth0-vue';
import {RETURN_ROUTE_KEY} from './useReturnRoute/useReturnRoute';
import {SIDE_MENU_COLLAPSED} from '@/composables/useSidebarToggle';

const PERSISTENT_LOCALSTORAGE_KEYS = [
  'defaultCouponCode',
  'returnUrl',
  'campaign-id',
  SIDE_MENU_COLLAPSED,
  RETURN_ROUTE_KEY,
];

/**
 * Helper hook to manage login and logout functions.
 */
const useAuth = () => {
  const auth0 = useAuth0();

  const getToken = async () => {
    const token = await auth0.getAccessTokenSilently({
      scope: 'openid',
    });

    return token;
  };

  /*
   * Logs an user out of the app and auth0.
   * Also removes localstorage items, such as impersonated user.
   */
  const logout = async (returnTo?: string) => {
    const storageKeys: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key) {
        storageKeys.push(key);
      }
    }

    storageKeys
      .filter((key: string) => {
        return !key.startsWith('features.') && !PERSISTENT_LOCALSTORAGE_KEYS.includes(key);
      })
      .forEach((key: string) => {
        localStorage.removeItem(key);
      });

    // forcibly remove the impersonated user, if there.
    window.localStorage.removeItem('impersonatedUserId');

    await auth0.logout({
      returnTo: returnTo ?? window.location.origin,
    });
  };

  const setAuth0ImpersonatedAccountId = (id: string) => {
    window.localStorage.setItem('auth0_impersonated_account_id', id);
  };

  const getAuth0ImpersonatedAccountId = () => {
    return window.localStorage.getItem('auth0_impersonated_account_id');
  };

  return {
    auth0,
    setAuth0ImpersonatedAccountId,
    getAuth0ImpersonatedAccountId,
    getToken,
    logout,
  };
};

export default useAuth;
